module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-grey-c1b2b0dd.png";